/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { icon_search as searchIcon } from '@sick-davinci/material-icons/action/search.icon';
import { icon_info as aboutIcon } from '@sick-davinci/material-icons/action/info.icon';
import { icon_language as languageIcon } from '@sick-davinci/material-icons/action/language.icon';
import { icon_apps as appsIcon } from '@sick-davinci/material-icons/navigation/apps.icon';
import { icon_person as userIcon } from '@sick-davinci/material-icons/social/person.icon';
import { icon_more_vert as menuIcon } from '@sick-davinci/material-icons/navigation/more_vert.icon';

/**
 * Definition of the default standard buttons
 */
export const standardButtons = {
  search: {
    id: 'std_search',
    title: 'search',
    iconSrc: searchIcon
  },
  about: {
    id: 'std_about',
    title: 'about',
    iconSrc: aboutIcon
  },
  language: {
    id: 'std_language',
    title: 'language',
    iconSrc: languageIcon
  },
  apps: {
    id: 'std_apps',
    title: 'apps',
    iconSrc: appsIcon
  },
  user: {
    id: 'std_user',
    title: 'user',
    iconSrc: userIcon
  },
  menu: {
    id: 'std_menu',
    title: 'more',
    iconSrc: menuIcon
  }
};
